logErrors